import { Field, FieldProps } from 'formik'
import * as React from 'react'
import Select from 'react-select'
import { IFormValues } from './AddAssistanceCreateForm'

interface IDropdownOption {
  label: string
  value: string
}

const Dropdown = (props: {
  name: string
  options: IDropdownOption[]
  defaultOption: IDropdownOption
  placeholder: string
}) => {
  const getSelect = (form: any) => {
    const handleSelect = (event: any) => {
      form.setFieldValue(props.name, event.value)
    }
    return (
      <Select
        clearable={false}
        name='category'
        value={form.values[props.name]}
        onChange={handleSelect}
        options={props.options}
      />
    )
  }

  return (
    <Field name={props.name}>
      {({ field, form }: FieldProps<IFormValues>) => <div className='mt1'>{getSelect(form)}</div>}
    </Field>
  )
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/assistance/AddAsistanceForm/Dropdown.tsx